module.exports = __webpack_public_path__ + "img/SR_ICON_Umsatz.9e850891.svg";